import React, { useMemo } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { reduce } from 'lodash';
import RatingChart from '../widgets/RatingChart';
import CardWidget from '../widgets/CardWidget';
import { WidgetName, WidgetType } from '../../../shared/models/insights';
import { selectInsightsData } from '../../../store/selectors/insights.selectors';

const widgets = [{
  title: 'FEEDBACK EVENTS',
  field: WidgetName.Feedback,
  type: WidgetType.Value,
  completedTasksScreen: true,
}, {
  title: 'FEEDBACK COMMENTS',
  field: WidgetName.FeedbackComment,
  type: WidgetType.Value,
  completedTasksScreen: true,
}];

const CustomerFeedback = () => {
  const history = useHistory();
  const data = useSelector(selectInsightsData);

  const computedData = useMemo(() => {
    return reduce(data?.tasks, (result, value) => {
      const rating_chart = [...result.rating_chart];
      rating_chart[value.feedback_rating] += (+value.feedback_rating > 0 ? 1 : 0);

      return {
        [WidgetName.Feedback]: result[WidgetName.Feedback] + (+value.feedback_rating > 0 ? 1 : 0),
        [WidgetName.FeedbackComment]: result[WidgetName.FeedbackComment] + (value.feedback_comment ? 1 : 0),
        rating_chart
      };
    }, {
      [WidgetName.Feedback]: 0,
      [WidgetName.FeedbackComment]: 0,
      rating_chart: new Array(6).fill(0),
    });
  }, [data?.tasks]);

  const goCompletedScreen = (filterName) => {
    if (filterName) {
      history.push(`/insights/tasks/${filterName}`);
    }
  };

  return (
    <CRow>
      <CCol md={12}>
        <CCard className="glympser-container--roundedWithShadow">
          <CCardHeader className="border-0 glympser-roundedTop">
            Customer Feedback
          </CCardHeader>
          <CCardBody>
            <CRow className="pl-3">
              <CCol md={3}>
                {
                  widgets.map((widget) => {
                    return (
                      <CRow key={widget.title}>
                        <CardWidget
                          widget={widget}
                          data={computedData[widget.field]}
                          clickHandler={goCompletedScreen}
                        />
                      </CRow>
                    );
                  })
                }
              </CCol>
              <CCol md={9}>
                <RatingChart data={computedData?.rating_chart}/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default CustomerFeedback;
